export default class GPEinladungDto {

  constructor(json) {
    if (json) {
      this.json = json
      this.empfaenger = json.empfaenger
      this.token = json.token
      this.createdAt = json.createdAt
      this.validUntil = json.validUntil
      this.status = json.status
      this.gpExtId = json.gpExtId
    } else {
      this.json = {}
    }
   }

  get einladungStatus() {
    return 'status.' + this.status.toLowerCase()
  }
}
